/* Dual-handle price range slider for the collection filter panel.

   Delegated on document rather than bound to the individual inputs: the
   facet panel's innerHTML gets replaced wholesale on every AJAX filter
   update (see collection.js), which would silently drop any listener
   attached directly to a slider that then gets swapped out. Delegation
   survives that replacement for free — nothing here needs to re-run
   after a re-render. */
(function () {
  function format(value, template) {
    // template is a previously-rendered "$12.34"-shaped string; reused so
    // the currency symbol and its position stay whatever Shopify's own
    // money filter produced server-side, rather than hardcoding "$".
    var symbolBefore = /^[^\d]*/.exec(template)[0];
    var symbolAfter = /[^\d]*$/.exec(template)[0];
    return symbolBefore + value.toFixed(2) + symbolAfter;
  }

  function slidersIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-price-slider]'));
  }

  // Only the fill bar's position - deliberately leaves the value labels
  // alone. Liquid renders the unfiltered max as the collection's exact
  // price ("$657.95"), one cent short of the slider's own ceiled-to-a-
  // whole-dollar max attribute (658) that a step:1 range needs to be
  // draggable to its end - recomputing the label from that input's value
  // on load would round the real price away before a shopper ever touches
  // the slider. Labels only start reflecting the input values once a drag
  // actually happens (see fullSync/guard below).
  function positionFill(slider) {
    var min = slider.querySelector('[data-price-input="min"]');
    var max = slider.querySelector('[data-price-input="max"]');
    var fill = slider.querySelector('[data-price-fill]');
    if (!min || !max || !fill) return;

    var lo = parseFloat(min.value);
    var hi = parseFloat(max.value);
    var bound = parseFloat(slider.dataset.max) || 1;

    fill.style.left = (lo / bound) * 100 + '%';
    fill.style.right = 100 - (hi / bound) * 100 + '%';
  }

  // Fill position plus the value labels - used once a shopper actually
  // moves a handle, when reflecting the input's own value is correct.
  function fullSync(slider) {
    var min = slider.querySelector('[data-price-input="min"]');
    var max = slider.querySelector('[data-price-input="max"]');
    var minDisplay = slider.querySelector('[data-price-display="min"]');
    var maxDisplay = slider.querySelector('[data-price-display="max"]');
    if (!min || !max) return;

    positionFill(slider);

    if (minDisplay) minDisplay.textContent = format(parseFloat(min.value), minDisplay.textContent);
    if (maxDisplay) maxDisplay.textContent = format(parseFloat(max.value), maxDisplay.textContent);
  }

  // Keeps the two handles from crossing. Nudging the trailing handle along
  // with the leading one (rather than just clamping it in place) is what
  // makes a dual-range slider feel like one control instead of two
  // fighting each other at the middle.
  function guard(event) {
    var input = event.target;
    if (!input.matches('[data-price-input]')) return;

    var slider = input.closest('[data-price-slider]');
    if (!slider) return;

    var min = slider.querySelector('[data-price-input="min"]');
    var max = slider.querySelector('[data-price-input="max"]');

    if (input === min && parseFloat(min.value) > parseFloat(max.value)) {
      max.value = min.value;
    } else if (input === max && parseFloat(max.value) < parseFloat(min.value)) {
      min.value = max.value;
    }

    fullSync(slider);
  }

  document.addEventListener('input', guard);

  // Every slider that exists at any point (first load, an AJAX swap, or a
  // theme-editor re-render) only gets its fill bar positioned, never its
  // labels rewritten - see positionFill's own comment for why.
  slidersIn(document).forEach(positionFill);

  document.addEventListener('shopify:section:load', function (event) {
    slidersIn(event.target).forEach(positionFill);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-price-slider]')) positionFill(node);
        else if (node.querySelectorAll) slidersIn(node).forEach(positionFill);
      });
    });
  });

  var facets = document.getElementById('PbFacets');
  if (facets) observer.observe(facets, { childList: true, subtree: true });
})();
